import * as Yup from "yup";

const MIN_NAME_LENGTH: number = 3;
const MAX_NAME_LENGTH: number = 80;
const MIN_DESCRIPTION_LENGTH: number = 3;
const MAX_DESCRIPTION_LENGTH: number = 250;
const MAX_TASK_LENGTH: number = 3;

const AddEmpowerMeBundleValidator = Yup.object({
    name : Yup.string()
        .required("Name is Required")
        .min(
            MIN_NAME_LENGTH,
            `Name must be at least ${MIN_NAME_LENGTH} characters long`
        )
        .max(
            MAX_NAME_LENGTH,
            `Name must be less than ${MAX_NAME_LENGTH} characters long`
        ),
    status_raw : Yup.string()
        .oneOf(["true", "false"], "Invalid status")
        .required("Status is required"),
    description : Yup.string()
        .required("Description is required")
        .min(
            MIN_DESCRIPTION_LENGTH,
            `Description text must be at least ${MIN_DESCRIPTION_LENGTH} characters long`
        )
        .max(
            MAX_DESCRIPTION_LENGTH,
            `Description text must be less than ${MAX_DESCRIPTION_LENGTH} characters long`
        ),
    bundle_category_id : Yup.string()
        .required("Category is required"),
    tasks_raw : Yup.array()
        .required("Tasks are required")
        .min(MAX_TASK_LENGTH, `You must have exactly ${MAX_TASK_LENGTH} tasks`)
        .max(MAX_TASK_LENGTH, `You must have exactly ${MAX_TASK_LENGTH} tasks`),
    

});

export default AddEmpowerMeBundleValidator;